import { render } from "./CustomerContainer.vue?vue&type=template&id=170e8202&ts=true"
import script from "./CustomerContainer.vue?vue&type=script&lang=ts"
export * from "./CustomerContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__